import {PropsWithChildren, useState} from 'react';
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';

export interface IMarkerWithInfoWindowParams {
    position: google.maps.LatLng | google.maps.LatLngLiteral | null;
    title: string;
}

export const MarkerWithInfoWindow = (params: PropsWithChildren<IMarkerWithInfoWindowParams>) => {
  const [infoWindowOpen, setInfoWindowOpen] = useState(true);
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        onClick={() => setInfoWindowOpen(true)}
        position={params.position}
        title={params.title}
      />
      {infoWindowOpen && (
        <InfoWindow
          anchor={marker}
          maxWidth={200}
          onCloseClick={() => setInfoWindowOpen(false)}>
          {params.children}
        </InfoWindow>
      )}
    </>
  );
};